// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from 'react';

// Simulated sign-in log across ALL 21 apps
const SIGN_LOG = [
  { id: 1, user: 'Ryan Miskulin', email: 'rmiskulin@gmail.com', app: 'MT Forge', brand: 'MT Forge', action: 'Login', time: '2026-02-10 21:45', ip: '174.6.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 2, user: 'Jordan Lutz', email: 'J.lutz@miskulintechnologies.com', app: 'MT Forge', brand: 'MT Forge', action: 'Login', time: '2026-02-10 21:42', ip: '184.65.xx.xx', device: 'Chrome / macOS', status: 'success' },
  { id: 3, user: 'Ryan Miskulin', email: 'rmiskulin@gmail.com', app: 'Vantage Ops', brand: 'Vantage Ops', action: 'Login', time: '2026-02-10 21:30', ip: '174.6.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 4, user: 'Suzanne Lutz', email: 'S.lutz@miskulintechnologies.com', app: 'Vantage Ops', brand: 'Vantage Ops', action: 'Login', time: '2026-02-10 21:15', ip: '184.65.xx.xx', device: 'Safari / iPad', status: 'success' },
  { id: 5, user: 'Suzanne Lutz', email: 'S.lutz@miskulintechnologies.com', app: 'Vantage Ops', brand: 'Vantage Ops', action: 'Failed Login', time: '2026-02-10 21:14', ip: '184.65.xx.xx', device: 'Safari / iPad', status: 'failed' },
  { id: 6, user: 'Taylor Schenher', email: 'threewayindustries@gmail.com', app: 'Forge Fleet', brand: 'Haul Logic', action: 'Login', time: '2026-02-10 20:58', ip: '207.81.xx.xx', device: 'Chrome / Android', status: 'success' },
  { id: 7, user: 'Lucas Mason', email: 'lucas.s.mason@gmail.com', app: 'Directional Ops', brand: 'DirectionalOps', action: 'Login', time: '2026-02-10 20:45', ip: '142.68.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 8, user: 'Lee Mehling', email: 'leemehling@hotmail.com', app: 'HerdLedger', brand: 'HerdLedger', action: 'Login', time: '2026-02-10 20:30', ip: '184.151.xx.xx', device: 'Safari / iPhone', status: 'success' },
  { id: 9, user: 'Tyson Becker', email: 'tyson@canstorr.com', app: 'CropPatrol', brand: 'CropPatrol', action: 'Login', time: '2026-02-10 20:22', ip: '96.20.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 10, user: 'Des Bachynski', email: 'desbachynski@gmail.com', app: 'VitaSync', brand: 'VitaSync', action: 'Login', time: '2026-02-10 20:10', ip: '24.87.xx.xx', device: 'Chrome / macOS', status: 'success' },
  { id: 11, user: 'Che LeBlanc', email: 'che@rosebudcannabisfarms.ca', app: 'BudLedger', brand: 'BudLedger', action: 'Login', time: '2026-02-10 19:55', ip: '70.27.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 12, user: 'Tyler Hodgson', email: 'tyler.hodgson32@gmail.com', app: 'OreSync', brand: 'OreSync', action: 'Login', time: '2026-02-10 19:40', ip: '68.148.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 13, user: 'Clorice Robertson', email: 'cloricer77@gmail.com', app: 'MT Forge', brand: 'MT Forge', action: 'Login', time: '2026-02-10 19:35', ip: '206.75.xx.xx', device: 'Edge / Windows', status: 'success' },
  { id: 14, user: 'Jordan Lutz', email: 'J.lutz@miskulintechnologies.com', app: 'Directional Ops', brand: 'DirectionalOps', action: 'Login', time: '2026-02-10 19:20', ip: '184.65.xx.xx', device: 'Chrome / macOS', status: 'success' },
  { id: 15, user: 'Derek Little', email: 'littlesderek@gmail.com', app: 'VacTraq', brand: 'VacTraq', action: 'Login', time: '2026-02-10 19:10', ip: '99.226.xx.xx', device: 'Chrome / Android', status: 'success' },
  { id: 16, user: 'Laken Weston', email: 'laken.weston@live.ca', app: 'GlowDesk', brand: 'GlowDesk', action: 'Login', time: '2026-02-10 18:50', ip: '75.155.xx.xx', device: 'Safari / iPhone', status: 'success' },
  { id: 17, user: 'Amanda Henwood', email: 'amandakristaleigh@hotmail.com', app: 'NurseVault', brand: 'NurseVault', action: 'Login', time: '2026-02-10 18:40', ip: '64.229.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 18, user: 'Shanon Lutz', email: 'shanon@lanewaymedia.ca', app: 'StageVault', brand: 'StageVault', action: 'Login', time: '2026-02-10 18:25', ip: '173.206.xx.xx', device: 'Safari / macOS', status: 'success' },
  { id: 19, user: 'Jake Hansen', email: 'jhansen860@yahoo.com', app: 'WrenchSync', brand: 'WrenchSync', action: 'Login', time: '2026-02-10 18:10', ip: '76.68.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 20, user: 'Darren Blahut', email: 'dblahut@sastel.net', app: 'PolicyForge', brand: 'PolicyForge', action: 'Login', time: '2026-02-10 17:55', ip: '142.165.xx.xx', device: 'Edge / Windows', status: 'success' },
  { id: 21, user: 'Ryan Miskulin', email: 'rmiskulin@gmail.com', app: 'ClosingDesk', brand: 'ClosingDesk', action: 'Login', time: '2026-02-10 17:30', ip: '174.6.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 22, user: 'Jordan Lutz', email: 'J.lutz@miskulintechnologies.com', app: 'TreadOps', brand: 'TreadOps', action: 'Login', time: '2026-02-10 17:15', ip: '184.65.xx.xx', device: 'Chrome / macOS', status: 'success' },
  { id: 23, user: 'Ryan Miskulin', email: 'rmiskulin@gmail.com', app: 'LotSync', brand: 'LotSync', action: 'Login', time: '2026-02-10 16:50', ip: '174.6.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 24, user: 'Jordan Lutz', email: 'J.lutz@miskulintechnologies.com', app: 'NurseVault CA', brand: 'NurseVault CA', action: 'Login', time: '2026-02-10 16:35', ip: '184.65.xx.xx', device: 'Chrome / macOS', status: 'success' },
  { id: 25, user: 'Demo Account', email: 'demo@iqapps.dev', app: 'Vantage Ops', brand: 'Vantage Ops', action: 'Login', time: '2026-02-10 16:20', ip: '174.6.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 26, user: 'Ryan Miskulin', email: 'rmiskulin@gmail.com', app: 'IronLedger', brand: 'IronLedger', action: 'Login', time: '2026-02-10 16:00', ip: '174.6.xx.xx', device: 'Chrome / Windows', status: 'success' },
  { id: 27, user: 'Suzanne Lutz', email: 'S.lutz@miskulintechnologies.com', app: 'Vantage Ops', brand: 'Vantage Ops', action: 'NDA Signed', time: '2026-02-10 15:45', ip: '184.65.xx.xx', device: 'Safari / iPad', status: 'success' },
  { id: 28, user: 'Suzanne Lutz', email: 'S.lutz@miskulintechnologies.com', app: 'Vantage Ops', brand: 'Vantage Ops', action: 'Password Changed', time: '2026-02-10 15:44', ip: '184.65.xx.xx', device: 'Safari / iPad', status: 'success' },
  { id: 29, user: 'Unknown', email: 'hacker@fake.com', app: 'Directional Ops', brand: 'DirectionalOps', action: 'Failed Login', time: '2026-02-10 14:22', ip: '185.220.xx.xx', device: 'Firefox / Linux', status: 'failed' },
  { id: 30, user: 'Unknown', email: 'admin@test.com', app: 'MT Forge', brand: 'MT Forge', action: 'Failed Login', time: '2026-02-10 13:10', ip: '91.240.xx.xx', device: 'Chrome / Windows', status: 'failed' },
];

const ALL_APPS = [
  'All Apps', 'MT Forge', 'Vantage Ops', 'Directional Ops', 'CropPatrol', 'Forge Fleet',
  'OreSync', 'BudLedger', 'NurseVault', 'NurseVault CA', 'LotSync', 'VacTraq', 'GlowDesk',
  'ClosingDesk', 'WrenchSync', 'TreadOps', 'HerdLedger', 'VitaSync', 'PolicyForge',
  'StageVault', 'IronLedger', 'BrodaFarms'
];

const ALL_STATUSES = ['All', 'success', 'failed'];

export default function SignLogPage() {
  const [filterApp, setFilterApp] = useState('All Apps');
  const [filterStatus, setFilterStatus] = useState('All');
  const [filterUser, setFilterUser] = useState('');

  const filtered = SIGN_LOG.filter(entry => {
    if (filterApp !== 'All Apps' && entry.app !== filterApp) return false;
    if (filterStatus !== 'All' && entry.status !== filterStatus) return false;
    if (filterUser && !entry.user.toLowerCase().includes(filterUser.toLowerCase()) && !entry.email.toLowerCase().includes(filterUser.toLowerCase())) return false;
    return true;
  });

  const totalLogins = SIGN_LOG.filter(e => e.status === 'success' && e.action === 'Login').length;
  const failedLogins = SIGN_LOG.filter(e => e.status === 'failed').length;
  const uniqueUsers = [...new Set(SIGN_LOG.filter(e => e.status === 'success').map(e => e.email))].length;
  const uniqueApps = [...new Set(SIGN_LOG.filter(e => e.status === 'success').map(e => e.app))].length;

  // Activity by app
  const appCounts = {};
  SIGN_LOG.filter(e => e.status === 'success').forEach(e => {
    appCounts[e.brand] = (appCounts[e.brand] || 0) + 1;
  });
  const sortedApps = Object.entries(appCounts).sort((a, b) => b[1] - a[1]);
  const maxCount = sortedApps.length > 0 ? sortedApps[0][1] : 1;

  return (
    <>
      <div className="page-header">
        <div>
          <div className="page-title">Sign Log</div>
          <div className="page-subtitle">Login activity across all 21 apps — real-time audit trail</div>
        </div>
      </div>
      <div className="page-body">
        {/* Stats */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value" style={{ color: '#22c55e' }}>{totalLogins}</div>
            <div className="stat-label">Successful Logins</div>
          </div>
          <div className="stat-card">
            <div className="stat-value" style={{ color: '#ef4444' }}>{failedLogins}</div>
            <div className="stat-label">Failed Attempts</div>
          </div>
          <div className="stat-card">
            <div className="stat-value" style={{ color: '#3b82f6' }}>{uniqueUsers}</div>
            <div className="stat-label">Unique Users</div>
          </div>
          <div className="stat-card">
            <div className="stat-value" style={{ color: '#a855f7' }}>{uniqueApps}</div>
            <div className="stat-label">Apps Accessed</div>
          </div>
        </div>

        {/* Activity by App */}
        <div className="card">
          <div className="card-title">Activity by App</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 12 }}>
            {sortedApps.map(([app, count]) => (
              <div key={app} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 140, fontSize: 12, color: 'var(--text-secondary)', textAlign: 'right', flexShrink: 0 }}>{app}</div>
                <div style={{ flex: 1, background: 'var(--border)', borderRadius: 4, height: 22, overflow: 'hidden' }}>
                  <div style={{ width: `${(count / maxCount) * 100}%`, height: '100%', background: 'var(--primary)', borderRadius: 4, display: 'flex', alignItems: 'center', paddingLeft: 8, fontSize: 11, fontWeight: 700, color: '#fff', minWidth: 28 }}>
                    {count}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Filters */}
        <div className="card" style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>Filters:</div>
          <select className="input" style={{ width: 200 }} value={filterApp} onChange={e => setFilterApp(e.target.value)}>
            {ALL_APPS.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
          <select className="input" style={{ width: 140 }} value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
            {ALL_STATUSES.map(s => <option key={s} value={s}>{s === 'All' ? 'All Status' : s === 'success' ? '✓ Success' : '✗ Failed'}</option>)}
          </select>
          <input
            className="input"
            style={{ width: 220 }}
            placeholder="Search by name or email..."
            value={filterUser}
            onChange={e => setFilterUser(e.target.value)}
          />
          <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{filtered.length} entries</div>
        </div>

        {/* Log Table */}
        <div className="card" style={{ padding: 0 }}>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>User</th>
                  <th>Email</th>
                  <th>App</th>
                  <th>Brand</th>
                  <th>Action</th>
                  <th>Device</th>
                  <th>IP</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(entry => (
                  <tr key={entry.id} style={{ background: entry.status === 'failed' ? 'rgba(239,68,68,0.06)' : 'transparent' }}>
                    <td style={{ whiteSpace: 'nowrap', fontSize: 12 }}>{entry.time}</td>
                    <td style={{ fontWeight: 600 }}>{entry.user}</td>
                    <td style={{ fontSize: 11, color: 'var(--text-muted)' }}>{entry.email}</td>
                    <td>{entry.app}</td>
                    <td>
                      <span style={{
                        padding: '2px 8px',
                        borderRadius: 4,
                        fontSize: 11,
                        fontWeight: 700,
                        background: 'rgba(59,130,246,0.15)',
                        color: '#60a5fa'
                      }}>{entry.brand}</span>
                    </td>
                    <td>{entry.action}</td>
                    <td style={{ fontSize: 11, color: 'var(--text-muted)' }}>{entry.device}</td>
                    <td style={{ fontSize: 11, fontFamily: 'monospace', color: 'var(--text-muted)' }}>{entry.ip}</td>
                    <td>
                      <span style={{
                        padding: '3px 10px',
                        borderRadius: 12,
                        fontSize: 11,
                        fontWeight: 700,
                        background: entry.status === 'success' ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)',
                        color: entry.status === 'success' ? '#22c55e' : '#ef4444'
                      }}>
                        {entry.status === 'success' ? '✓ Success' : '✗ Failed'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Security Alerts */}
        <div className="card">
          <div className="card-title" style={{ color: '#ef4444' }}>⚠ Security Alerts</div>
          <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
            {SIGN_LOG.filter(e => e.status === 'failed').map(entry => (
              <div key={entry.id} style={{
                padding: '10px 14px',
                background: 'rgba(239,68,68,0.08)',
                border: '1px solid rgba(239,68,68,0.2)',
                borderRadius: 8,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 8
              }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#ef4444' }}>{entry.action} — {entry.app} ({entry.brand})</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>
                    {entry.email} • {entry.ip} • {entry.device} • {entry.time}
                  </div>
                </div>
                <span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700, background: 'rgba(239,68,68,0.15)', color: '#ef4444' }}>
                  BLOCKED
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Info */}
        <div className="card" style={{ borderLeft: '3px solid var(--primary)' }}>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            <strong>How It Works:</strong> Every login attempt across all 21 Mt Forge apps is logged here in real time via Supabase Auth events.
            This includes successful logins, failed attempts, password changes, NDA signatures, and session activity.
            All data flows through the shared Supabase instance and is accessible only to founders (Ryan & Jordan).
            <br /><br />
            <strong>Security:</strong> Failed login attempts from unknown IPs are automatically flagged. Repeated failures from the same IP trigger alerts.
            Team members using their registered emails (personal or company) will always show their name. Unknown emails are flagged for review.
          </div>
        </div>
      </div>
    </>
  );
}
